import {
	InspectorControls,
	PanelColorSettings,
} from '@wordpress/block-editor';
import {
	PanelBody,
	SelectControl,
	RangeControl,
	__experimentalUnitControl as UnitControl,
	__experimentalBoxControl as BoxControl,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';

import { TAB_ORIENTATIONS, TAB_POSITIONS, TAB_ALIGNMENTS } from '../constants';

export default function Settings( { attributes, setAttributes } ) {
	const {
		orientation,
		tabPosition,
		tabAlignment,
		tabWidth,
		activeTabColor,
		activeTabBg,
		hoverTabColor,
		hoverTabBg,
		inactiveTabBg,
		inactiveTabColor,
		tabGap,
		contentPadding,
		initialTab,
	} = attributes;

	// Detect active block style from WP className
	const activeStyle =
		( attributes.className || '' ).match(
			/is-style-(\w+)/
		)?.[ 1 ] || 'underline';
	const hasBg = activeStyle !== 'underline';

	return (
		<InspectorControls>
			<PanelBody
				title={ __( 'Tab Settings', 'brandy-blocks' ) }
			>
				<SelectControl
					label={ __( 'Orientation', 'brandy-blocks' ) }
					value={ orientation }
					options={ TAB_ORIENTATIONS }
					onChange={ ( value ) =>
						setAttributes( {
							orientation: value,
							tabPosition:
								value === 'vertical' ? 'left' : 'top',
						} )
					}
				/>
				<SelectControl
					label={ __( 'Position', 'brandy-blocks' ) }
					value={ tabPosition }
					options={ TAB_POSITIONS[ orientation ] }
					onChange={ ( value ) =>
						setAttributes( { tabPosition: value } )
					}
				/>
				<SelectControl
					label={ __( 'Alignment', 'brandy-blocks' ) }
					value={ tabAlignment }
					options={ TAB_ALIGNMENTS }
					onChange={ ( value ) =>
						setAttributes( { tabAlignment: value } )
					}
				/>
				<RangeControl
					label={ __(
						'Initial Active Tab',
						'brandy-blocks'
					) }
					value={ initialTab }
					onChange={ ( value ) =>
						setAttributes( { initialTab: value } )
					}
					min={ 1 }
					max={ 10 }
					step={ 1 }
					help={ __(
						'1 = first tab, 2 = second, etc.',
						'brandy-blocks'
					) }
				/>
				{ orientation === 'vertical' && (
					<UnitControl
						label={ __( 'Tab Width', 'brandy-blocks' ) }
						value={ tabWidth }
						onChange={ ( value ) =>
							setAttributes( { tabWidth: value } )
						}
						units={ [
							{ value: 'px', label: 'px', default: 150 },
							{ value: '%', label: '%', default: 20 },
							{ value: 'rem', label: 'rem', default: 10 },
						] }
					/>
				) }
				<UnitControl
					label={ __( 'Tab Gap', 'brandy-blocks' ) }
					value={ tabGap }
					onChange={ ( value ) =>
						setAttributes( { tabGap: value } )
					}
					units={ [
						{ value: 'px', label: 'px', default: 0 },
						{ value: 'rem', label: 'rem', default: 0 },
					] }
				/>
			</PanelBody>
			<PanelColorSettings
				title={ __( 'Tab Colors', 'brandy-blocks' ) }
				initialOpen={ false }
				colorSettings={ [
					{
						value: activeTabColor,
						onChange: ( value ) =>
							setAttributes( {
								activeTabColor: value,
							} ),
						label: __(
							'Active Tab Color',
							'brandy-blocks'
						),
					},
					hasBg && {
						value: activeTabBg,
						onChange: ( value ) =>
							setAttributes( {
								activeTabBg: value,
							} ),
						label: __(
							'Active Tab Background',
							'brandy-blocks'
						),
					},
					{
						value: hoverTabColor,
						onChange: ( value ) =>
							setAttributes( {
								hoverTabColor: value,
							} ),
						label: __(
							'Hover Tab Color',
							'brandy-blocks'
						),
					},
					hasBg && {
						value: hoverTabBg,
						onChange: ( value ) =>
							setAttributes( {
								hoverTabBg: value,
							} ),
						label: __(
							'Hover Tab Background',
							'brandy-blocks'
						),
					},
					hasBg && {
						value: inactiveTabBg,
						onChange: ( value ) =>
							setAttributes( {
								inactiveTabBg: value,
							} ),
						label: __(
							'Inactive Tab Background',
							'brandy-blocks'
						),
					},
					{
						value: inactiveTabColor,
						onChange: ( value ) =>
							setAttributes( {
								inactiveTabColor: value,
							} ),
						label: __(
							'Inactive Tab Color',
							'brandy-blocks'
						),
					},
				].filter( Boolean ) }
			/>
			<PanelBody
				title={ __( 'Content', 'brandy-blocks' ) }
				initialOpen={ false }
			>
				<BoxControl
					label={ __(
						'Content Padding',
						'brandy-blocks'
					) }
					values={ contentPadding }
					onChange={ ( value ) =>
						setAttributes( { contentPadding: value } )
					}
				/>
			</PanelBody>
		</InspectorControls>
	);
}
